var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Modal, Flex, Box, ModalOverlay, ModalContent, ModalHeader, ModalBody, Text, VStack, HStack, Center, } from "@reverb-ui/react";
import { Person, PlusSquare } from "@reverb-ui/icons-react";
import { Link } from "react-router-dom";
import styled from "styled-components";
var RouterLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :focus-visible {\n    outline: none;\n  }\n"], ["\n  :focus-visible {\n    outline: none;\n  }\n"])));
var OptionCard = function (_a) {
    var icon = _a.icon, link = _a.link, subtitle = _a.subtitle, title = _a.title;
    return (React.createElement(RouterLink, { to: link, style: { width: "100%" } },
        React.createElement(HStack, { w: "full", p: 5, shadow: "sm", borderRadius: 8, borderWidth: 1, borderColor: "gray.200" },
            React.createElement(Flex, { w: "70px", justifyContent: "center", alignItems: "center" }, icon),
            React.createElement(VStack, { alignItems: "start" },
                React.createElement(Text, { fontSize: "md", color: "black", fontWeight: "medium" }, title),
                React.createElement(Text, { fontSize: "sm", color: "gray.800" }, subtitle)))));
};
export var SelectEntity = function () {
    return (React.createElement(Box, { w: "full" },
        React.createElement(Modal, { isOpen: true, onClose: function () { return null; } },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null,
                    React.createElement(Center, { pt: 3 },
                        React.createElement(Text, { fontSize: "md" }, "We found the e-mail you used in our database!"))),
                React.createElement(ModalBody, null,
                    React.createElement(VStack, { spacing: 8, pb: 5, pt: 3, px: 3 },
                        React.createElement(OptionCard, { title: "New company", subtitle: "Create a new company account", link: "/first-access/company", icon: React.createElement(PlusSquare, { size: 45, color: "gray.400" }) }),
                        React.createElement(OptionCard, { title: "Talent", subtitle: "Work on our Talent network.", link: "/first-access/talent", icon: React.createElement(Person, { size: 45, color: "gray.400" }) })))))));
};
var templateObject_1;
